import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "utils/useAuth/useAuth";
import { useSnackbar } from "notistack";
import { createPayfac } from "./model";
import s from "./AddPayfac.module.scss";
import Divider from "components/Divider/Divider";
import merchantManagement from "routes/merchantManagement";
import PayfacForm from "../components/PayfacForm";
import { usePayfacOptionsCache } from "utils/optionsCache/payfacOptionsCache";

const PAGE_LOCALE_KEY = "page.payfacs.addPayfac.";

const FIELD_INIT_STATE = {
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  address: "",
  phone: "",
  remarks: "",
  status: "ACTIVE",
  alipayMerchantIdPrefix: "",
  alipayStoreIdPrefix: "",
  alipayPartnerKey: "",
  alipayPartnerId: "",
  wechatMerchantId: "",
  wechatAppId: "",
  wechatSecret: "",
  wechatKey: "",
  yedpayPayfacId: "",
  yedpayKid: "",
  yedpayPayfacHashId: "",
  yedpayPayfacPrefix: "",
  payfacPrefix: "",
};

const AddPayfac = ({ path, redirectFn }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { invalidatePayfacOptionsCache } = usePayfacOptionsCache();
  const { enqueueSnackbar } = useSnackbar();

  const [submitting, setSubmitting] = useState(false);

  const snackbar = (message, variant, durationInMs = 2000) => {
    return enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      autoHideDuration: durationInMs,
    });
  };

  const handleSubmit = async (fieldInput) => {
    setSubmitting(true);
    const payload = { ...fieldInput };

    const apiResponse = await createPayfac(payload);
    if (!apiResponse || !apiResponse?.data) {
      snackbar(t("general.message.networkError"), "error");
    } else {
      switch (apiResponse.status) {
        case 401: {
          console.log("You have no authorization to view the page");
          return logout("TOKEN_EXPIRED");
        }
        case 403: {
          snackbar(t("general.message.unauthorized"), "error");
          break;
        }
        default: {
          const responseBody = apiResponse.data;
          if (responseBody.responseCode !== "0000") {
            snackbar(
              t(PAGE_LOCALE_KEY + "create.msgFailed") +
                (responseBody.message || ""),
              "error",
            );
          } else {
            invalidatePayfacOptionsCache();
            snackbar(t(PAGE_LOCALE_KEY + "create.msgSuccess"), "success");
            const newpath = "/merchant-management/payfacs/payfacs";
            const redirectpayload = {
              name: merchantManagement
                .find((tab) => tab.tabName === "PayFacs")
                .page.find((page) => page.path === newpath).name,
              path: newpath,
              refresh: true,
            };

            redirectFn("close", { tabId: path });
            redirectFn("redirectPage", redirectpayload);
          }
        }
      }
    }
    setSubmitting(false);
  };

  return (
    <div className={s.container}>
      <div className={s.contentContainer}>
        <div className={[s.detailsContainer].join(" ")}>
          <div className={s.agentDetails}>
            <div className={s.header}>
              <span>{t(PAGE_LOCALE_KEY + "sectionCreateTitle")}</span>
            </div>

            <Divider />
            <div className={s.formContentContainer}>
              <PayfacForm
                initialValues={FIELD_INIT_STATE}
                onSubmit={handleSubmit}
                submitting={submitting}
                gridId="AddPayfacGrid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AddPayfac);
